import { IndexPage } from "./index-page";

export { IndexPage }